if (!customElements.get('section-cart-drawer')) {
  class TG_SectionCartDrawer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.element = this;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.documentDelegate = new themegoal.libs.Delegate(document.documentElement);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
      this.itemCount = this.options['itemCount'];

      this.showCrossSell = this.options['showCrossSell'];
      this.firstItemProductId = this.options['firstItemProductId'];
      this.preFirstItemProductId = '0';
  
      this.sidebarDrawer = new themegoal.components.Drawer(this);
      this.element.addEventListener('hidden.tg.Drawer', this._onDrawerClosed.bind(this));
  
      this._bindEventsListeners();
    }

    disconnectedCallback(){
      if(this.delegateElement)this.delegateElement.destroy();
      if(this.documentDelegate)this.documentDelegate.destroy();
      if(this.sidebarDrawer)this.sidebarDrawer.hide();
    }
  
    _bindEventsListeners() {
      this.delegateElement.on('change', '#CartNote', this._updateCartNote.bind(this));
      this.delegateElement.on('click', '[data-action="update-item-quantity"], [data-action="remove-item"]', this._updateItemQuantity.bind(this));
      this.delegateElement.on('change', '.CartItem__QuantityNum', this._updateItemQuantity.bind(this));
  
      document.addEventListener('product:added', this._onProductAdded.bind(this));
  
      this.documentDelegate.on('cart:refresh', this._rerenderCart.bind(this, false));
    }

    _loadRecommendationsComplementary() {
      var _this = this;

      if(this.itemCount < 1){
        this.element.querySelector('.CartDrawerCrossSell').style.display = 'none';
        this.firstItemProductId = '0'
        this.preFirstItemProductId = '0'
      };
  
      if (this.firstItemProductId=='0' || _this.preFirstItemProductId == _this.firstItemProductId) return;

      var url = window.routes.productRecommendationsUrl + '?section_id=cart-drawer-cross-sell&intent=complementary&product_id=' + this.firstItemProductId + '&limit=' + this.options['recommendationsComplementaryCount'];
  
      return fetch(url).then(function (response) {
        return response.text().then(function (content) {
          var container = document.createElement('div');
          container.innerHTML = content;

          let recommendationsElement = _this.element.querySelector('.CartDrawerCrossSell .CartDrawerCrossSell__Body');
          let cartDrawerCrossSellHiddenFromsrecommendationsElement = _this.element.querySelector('.CartDrawerCrossSellHiddenFroms');

          if(container.querySelector('.Carousel__Item')){
            recommendationsElement.querySelector('.ProductList--carousel').innerHTML = container.querySelector(".CartDrawerCrossSell__Body").innerHTML;
            cartDrawerCrossSellHiddenFromsrecommendationsElement.innerHTML = container.querySelector(".CartDrawerCrossSellHiddenFroms").innerHTML;
            new themegoal.components.Carousel(recommendationsElement.querySelector('[data-carousel-config]'));
            _this.element.querySelector('.CartDrawerCrossSell').style.display = 'block';
          }else{
            _this.element.querySelector('.CartDrawerCrossSell').style.display = 'none';
          }

          _this.preFirstItemProductId = _this.firstItemProductId;
  
        });
      });
    }
  
    _updateCartNote(event, target) {
      fetch(window.routes.cartUrl + '/update.js', {
        body: JSON.stringify({ note: target.value }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' 
        }
      });
    }
  
    _updateItemQuantity(event, target) {
      var _this = this;
  
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
  
      var quantity = null,
          elementToAnimate = null;
  
      if (target.tagName === 'INPUT') {
        quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
      } else {
        quantity = parseInt(target.getAttribute('data-quantity'));
      }
  
      if (quantity === 0) {
        elementToAnimate = target.closest('.CartItem__Wrapper');
      }
  
      fetch(window.routes.cartChangeUrl + '.js', {
        body: JSON.stringify({ id: target.getAttribute('data-line-id'), quantity: quantity }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' 
        }
      }).then(function (cart) {
        cart.json().then(function (content) {
          _this.itemCount = content['item_count'];
          _this._rerenderCart(elementToAnimate);
  
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        });
      });
  
      event.preventDefault();
    }
  
    _onProductAdded(event) {
      var _this = this;
  
      this.itemCount += event.detail.quantity;
  
      this._rerenderCart().then(function () {
        if(!event.detail?.is_product_quickview){
        _this.sidebarDrawer.show();
        }
      });
    }
  
    _onDrawerClosed() {
      let cartDrawerNoteElement = document.getElementById('CartDrawerNoteCollapse');
      if(cartDrawerNoteElement){
        let cartDrawerNoteCollapse = new themegoal.components.Collapse(cartDrawerNoteElement, { toggle: false });
        cartDrawerNoteCollapse.hide();
      }
    }
  
    _rerenderCart(elementToAnimate) {
      var _this = this;
  
      return fetch(window.routes.cartUrl + '?section_id=cart-drawer&timestamp=' + Date.now(), {
        credentials: 'same-origin',
        method: 'GET'
      }).then(function (content) {
        if ( elementToAnimate ) {
          themegoal.libs.anime({
            targets: elementToAnimate,
            opacity: 0,
            height: 0,
            duration: 500,
            easing: 'easeOutCubic',
            complete: function(anim) {
              content.text().then(function (html) {
                _this._replaceContent(html);
              });
            }
          });
        } else {
          content.text().then(function (html) {
            _this._replaceContent(html);
          });
        }
      });
    }
  
    _replaceContent(html) {
      let _this = this;
  
      let tempElement = document.createElement('div');
      tempElement.innerHTML = html;
  
      let cartNodeParent = this.element.querySelector('.Form--cart').parentNode;

      let cartDrawerItemsParent = this.element.querySelector('.CartDrawer__Items').parentNode;
      let cartFooterParent = this.element.querySelector('.Drawer__Footer').parentNode;

      cartDrawerItemsParent.replaceChild(tempElement.querySelector('.CartDrawer__Items'), this.element.querySelector('.CartDrawer__Items'));
      cartFooterParent.replaceChild(tempElement.querySelector('.Drawer__Footer'), this.element.querySelector('.Drawer__Footer'));
  
      let currentScrollPosition = this.element.querySelector('.Drawer__Body').scrollTop;
      // cartNodeParent.replaceChild(tempElement.querySelector('.Form--cart'), this.element.querySelector('.Form--cart'));
      this.element.querySelector('.Drawer__Body').scrollTop = currentScrollPosition;
  
      let cartResult = JSON.parse(tempElement.querySelector('.CartDrawer').getAttribute('data-section-settings'));
  
      let cartCount = themegoal.helpers.Dom.nodeListToArray(document.querySelectorAll('.CartCountBubble')),
      cartText = themegoal.helpers.Dom.nodeListToArray(document.querySelectorAll('.CartCountText')),
      cartQuantity = themegoal.helpers.Dom.nodeListToArray(document.querySelectorAll('.CartCountBubble__Count'));
  
      this.itemCount = cartResult['itemCount'];
      this.firstItemProductId = cartResult['firstItemProductId'];
  
      cartCount.forEach(function (item) {
        if (_this.itemCount === 0) {
          item.classList.remove('Visible'); 
        } else {
          item.classList.add('Visible');
        }
      });
  
      cartText.forEach(function (item) {
        if (_this.itemCount === 0) {
          item.classList.add('Visible'); 
        } else {
          item.classList.remove('Visible');
        }
      });
  
      cartQuantity.forEach(function (item) {
        item.textContent = _this.itemCount;
      });


      if(this.options["freeShippingThreshold"]){
        let freeShippingElement = cartNodeParent.querySelector(".CartDrawer__ShippingAmountNotice");
        
  
        if(freeShippingElement){
          let cartTotalPrice = freeShippingElement.getAttribute("data-cart-total-price");
          let cartCurrencySymbol = freeShippingElement.getAttribute("data-cart-currency-symbol");
  
          cartTotalPrice = parseInt(cartTotalPrice);
  
          let freeShippingAmount = Math.round(this.options["freeShippingAmount"] * (Shopify.currency.rate || 1));
  
          if(cartTotalPrice >= freeShippingAmount){
            freeShippingElement.innerHTML = this.options["freeShippingString"];
          }else{
            let freeShippingAmountString = this.options["freeShippingAmountString"];
            freeShippingAmountString = freeShippingAmountString.replace("remaining__amount", "" + cartCurrencySymbol + (freeShippingAmount - cartTotalPrice)/100);
            freeShippingElement.innerHTML = freeShippingAmountString;
          }
        }
      }

      if (this.showCrossSell) {
        this._loadRecommendationsComplementary();
      }
    
    }
      
  }
        
  customElements.define('section-cart-drawer', TG_SectionCartDrawer);
}
